import PageList from '#/modules/commonComponents/PageList';
import warehouseNavigate from '#/modules/infra/navigation/warehouseNavigate';

const WarehouseHubPage = () => {
  return <PageList title="倉儲" linkList={warehouseNavigate} />;
};

export default WarehouseHubPage;
